import ProjectGallery from "../components/ProjectGallery.jsx"

const HomePage = () => {
  return <ProjectGallery />
}

export default HomePage
